import type { StressTestStatus } from '../types';

/** Compact seconds rendering: sub-second in ms, minutes once it gets long. */
export function formatSeconds(value: number | null | undefined): string {
  if (value == null) return '—';
  if (value < 1) return `${Math.round(value * 1000)} ms`;
  if (value < 60) return `${value.toFixed(1)} s`;
  const minutes = Math.floor(value / 60);
  return `${minutes}m ${Math.round(value % 60)}s`;
}

export function formatDuration(startedAt: string | null, finishedAt: string | null): string {
  if (!startedAt) return '—';
  const end = finishedAt ? new Date(finishedAt).getTime() : Date.now();
  return formatSeconds((end - new Date(startedAt).getTime()) / 1000);
}

export function formatTimestamp(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

export function formatClock(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleTimeString();
}

const STATUS_CLASSES: Record<StressTestStatus, string> = {
  pending: 'bg-slate-100 text-slate-600',
  running: 'bg-indigo-50 text-indigo-700',
  completed: 'bg-emerald-50 text-emerald-700',
  cancelled: 'bg-amber-50 text-amber-700',
  error: 'bg-red-50 text-red-700',
};

export function statusClasses(status: string): string {
  return STATUS_CLASSES[status as StressTestStatus] || 'bg-slate-100 text-slate-600';
}

/** The sentinel model type meaning "spread the run across every endpoint". */
export const RANDOM_MODEL_TYPE = 'random';

/** Human label for an endpoint key (`nano_banana_2` -> `Nano Banana 2`). */
export function endpointLabel(modelType: string): string {
  if (modelType === RANDOM_MODEL_TYPE) return 'Randomized';
  return modelType
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
